import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalConfirm from '../../shared/ui/modal-confirm/ui/ModalConfirm';
import { getAdminPlacementTestTemplates, deleteAdminPlacementTestTemplate } from '../../shared/api/placement-tests.services';
import { getLocalizedValue } from '../../shared/lib/localization';
import toast from '../../shared/lib/toast';

export default function QuickPlacementTestsPage() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const data = await getAdminPlacementTestTemplates();

      // Фільтруємо тільки quick тести
      const quickTests = data.filter(t => {
        const isQuickTest = t.id?.includes('quick') || t.slug?.includes?.('quick');
        return isQuickTest;
      });

      setTemplates(quickTests);
    } catch (error) {
      console.error('Error fetching templates:', error);
      toast.error('Помилка при завантаженні шаблонів');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (templateId) => {
    if (window.confirm('Ви впевнені, що хочете видалити цей шаблон?')) {
      try {
        const response = await deleteAdminPlacementTestTemplate(templateId);
        if (response?.ok || !response?.error) {
          toast.success('Шаблон успішно видалено!');
          fetchTemplates();
        } else {
          toast.error(response?.message || 'Помилка при видаленні');
        }
      } catch (err) {
        toast.error('Помилка при видаленні');
      }
    }
  };

  return (
    <>
      <ModalConfirm title="Ви впевнені, що хочете видалити цей шаблон?" />

      <section className="section-admin">
        {loading ? (
          <p>Завантаження...</p>
        ) : (
          <div className='admin-list'>
            <div className="admin-list__header">
              <p className="admin-list__header-info">
                {templates.length} Шаблонів
              </p>
              <div className="admin-list__header-func">
                {/* <button
                  onClick={() => navigate('/quick-placement-tests-rewrite/create')}
                  className='btn-primary'
                  style={{
                    padding: '6px 12px',
                    backgroundColor: '#081249',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                  }}
                >
                  Додати шаблон
                </button> */}
              </div>
            </div>

            <div className="admin-list__content">
              <ul className="admin-list__content-titles team-grid">
                <li>Назва</li>
                <li>Версія</li>
                <li>Статус</li>
                <li>Дія</li>
              </ul>
              <ul className="admin-list__content-items">
                {templates.length > 0 ? (
                  templates.map((template) => (
                    <div key={template.id} className='team-item team-grid'>
                      <div className="team-item__info">
                        <div className="team-item__info-txt">
                          <p className='team_name'>{getLocalizedValue(template.title, 'ua') || template.title}</p>
                        </div>
                      </div>

                      <div className="team-item__info">
                        <div className="team-item__info-txt">
                          <p className='team_role'>{template.id}</p>
                        </div>
                      </div>

                      <div className="team-item__info">
                        <div className={`team-item__status ${template.isActive ? 'is-visible' : 'is-hidden'}`}>
                          <p>{template.isActive ? 'Активна' : 'Неактивна'}</p>
                        </div>
                      </div>

                      <div className="team-item__func">
                        <button
                          onClick={() => navigate(`/quick-placement-tests-rewrite/${template.id}`)}
                          className='func-rewrite'
                          style={{
                            backgroundColor: '#081249',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '6px 12px',
                            cursor: 'pointer'
                          }}
                        >
                          Редагувати
                        </button>
                        <button
                          onClick={() => handleDelete(template.id)}
                          className='func-delete'
                          style={{
                            backgroundColor: '#FE0707',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '6px 12px',
                            cursor: 'pointer'
                          }}
                        >
                          Видалити
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <li className="admin-list__empty">Дані відсутні</li>
                )}
              </ul>
            </div>
          </div>
        )}
      </section>
    </>
  );
}
